
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/miniSite/auth",
      function () {
        return require("private-next-pages/miniSite/auth/index.miniSite.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/miniSite/auth"])
      });
    }
  